import React, { useMemo } from "react";
import {
  Button,
  Image,
  Popconfirm,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
  theme,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { getImageUrl } from "../api";
import StockStatus from "./StockStatus";

const { Text } = Typography;
const FALLBACK_IMAGE =
  "https://placehold.co/600x400/000000/FFFFFF/png?text=Sin+Imagen";

export default function ProductsTable({ products, loading, onEdit, onDelete }) {
  const { token } = theme.useToken();

  const columns = useMemo(
    () => [
      {
        title: "Producto",
        key: "product",
        render: (_, record) => (
          <Space>
            <Image
              src={getImageUrl(record.image)}
              alt={record.name}
              width={60}
              height={60}
              style={{ borderRadius: token.borderRadius, objectFit: "cover" }}
              fallback={FALLBACK_IMAGE}
            />
            <div style={{ maxWidth: 200 }}>
              <div>
                <Text strong>{record.name}</Text>
              </div>
              <Text
                type="secondary"
                style={{ fontSize: 12 }}
                ellipsis={{ tooltip: record.description }}
              >
                {record.description}
              </Text>
            </div>
          </Space>
        ),
      },
      {
        title: "Categoría",
        dataIndex: "category",
        render: (cat) => <Tag style={{ borderRadius: 10 }}>{cat}</Tag>,
      },
      {
        title: "Precios",
        key: "prices",
        render: (_, record) => (
          <Space orientation="vertical" size={0}>
            <Text strong style={{ color: token.colorPrimary }}>
              {record.price} Bravos
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {record.cash} MXN
            </Text>
          </Space>
        ),
      },
      {
        title: "Inventario",
        key: "inventory",
        render: (_, record) => (
          <StockStatus stock={record.stock} maxStock={record.max_stock} />
        ),
      },
      {
        title: "Colectivo",
        dataIndex: "is_colective",
        align: "center",
        render: (val) =>
          Number(val) ? (
            <Tag color="purple">Colectivo</Tag>
          ) : (
            <Tag color="default">Individual</Tag>
          ),
      },
      {
        title: "Acciones",
        key: "actions",
        fixed: "right",
        render: (_, record) => (
          <Space>
            <Tooltip title="Editar">
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => onEdit(record)}
              />
            </Tooltip>
            <Popconfirm
              title="¿Eliminar este producto?"
              okText="Eliminar"
              cancelText="Cancelar"
              okButtonProps={{ danger: true }}
              onConfirm={() => onDelete(record.id)}
            >
              <Tooltip title="Eliminar">
                <Button type="text" danger icon={<DeleteOutlined />} />
              </Tooltip>
            </Popconfirm>
          </Space>
        ),
      },
    ],
    [token, onEdit, onDelete]
  );

  return (
    <Table
      dataSource={products}
      columns={columns}
      loading={loading}
      rowKey="id"
      pagination={{ pageSize: 8 }}
      scroll={{ x: "max-content" }}
      bordered
      size="middle"
    />
  );
}
